<template>
  <div class="fts-pagination">
    <div class="pagination-summary">
      {{currentItemIndex}} of {{totalItems}}
    </div>

    <div class="pagination-control">
      <div class="pagination-container">
        <div class="page-item" :class="{ 'page-item-disabled': currentPage === 0 }" @click="firstPage">First</div>
        <template v-for="page in pageNumbers"> 
          <div class="page-item" v-if="page >= 0" :key="page" :class="{ 'page-item-active': currentPage === page }" @click="setCurrentPage(page)">
            {{page + 1}}
          </div>
        </template>
        <div class="page-item" :class="{ 'page-item-disabled': currentPage === Math.ceil(this.totalItems / this.pageSize) - 1 }" @click="lastPage">Last</div>
      </div>

      <fts-dropdown-select
        append-toggle-class="pagination-dropdown-toggle"
        placement="top-end"
        :options="pageList" 
        v-model="currentPageSize" />
    </div>

  </div>
</template>

<script>
import FTSDropdownSelect from "./FTSDropdownSelect";

export default {
  props: {
    totalItems: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 20
    }
  },
  model: {
    prop: "pageSize",
    event: "updatePageSize",
  },
  data: () => ({
    currentPage: 0,
    pageList: [ 10, 20, 50, 100, 200 ],
  }),
  components: {
    "fts-dropdown-select": FTSDropdownSelect,
  },
  methods: {
    setCurrentPage(page) {
      this.currentPage = page
    },
    firstPage() {
      this.currentPage = 0;
    },
    lastPage() {
      this.currentPage = Math.ceil(this.totalItems / this.pageSize) - 1;
    }
  },
  watch: {
    currentPage: function() {
      this.$emit('pageChanged', this.currentPage);
    },
    pageSize: function() {
      if ((this.currentPage * this.pageSize) + 1 > this.totalItems) {
        this.currentPage = Math.max(Math.ceil(this.totalItems / this.pageSize) - 1 ,0);
      } else {
        this.$emit('pageChanged', this.currentPage);
      }
    },
    totalItems: function() {
      this.currentPage = 0;
    }
  },
  computed: {
    currentItemIndex() {
      return `${(this.currentPage * this.pageSize) + 1} - ${Math.min((this.currentPage + 1) * this.pageSize, this.totalItems)}`;
    },
    pageNumbers() {
      let totalPage = Math.ceil(this.totalItems / this.pageSize)
      let pageNumbers = []

      let startPage1 = Math.max(this.currentPage - 2, 0);
      let startPage2 = Math.max(totalPage - 5, 0);
      let startPage = Math.min(startPage1, startPage2);

      for (var i = 0; i < 5; i++) {
        if(startPage + i < totalPage) {
          pageNumbers.push(startPage + i);
        }
      }

      return pageNumbers;
    },
    currentPageSize: {
      get() {
        return this.pageSize;
      },
      set(val) {
        this.$emit('updatePageSize', val);
      },
    },
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-pagination {
  @include user-select-none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0;
  font-size: .875rem;
  .pagination-summary {
    margin-right: .75rem;
    padding: 0.375rem;
    color: var(--fts-text);
  }
  .pagination-control {
    display: flex;
    align-items: center;
    color: var(--fts-gray-5);
    .pagination-container {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .page-item {
        padding: .375rem .575rem;
        &:hover {
          &:not(.page-item-disabled) {
          color: rgba($color: $primaryColor, $alpha: .85)
          }   
          cursor: pointer;
        }
        &.page-item-active {
          color: $primaryColor;
        }
        &.page-item-disabled {
          &:hover {
            cursor: not-allowed;
          }
        }
      }
    }  
    .pagination-dropdown-toggle {
      padding: .375rem .75rem; 
    }
  }
}
</style>